function CompanyLogo() {
  return (
    <svg
      width="161"
      height="36"
      viewBox="0 0 161 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.9563 16.9999L35.6868 14.8021L31.8329 8.12505C31.8148 8.09344 31.8072 8.05682 31.8113 8.02059C31.8155 7.98435 31.8311 7.9504 31.856 7.9237C33.1255 6.51936 33.5623 4.34546 32.4046 2.19373C32.0501 1.53993 31.5101 1.0056 30.8526 0.658001C27.7812 -0.973284 24.6935 0.631552 23.8233 3.24741C23.8123 3.28222 23.7905 3.3126 23.761 3.3341C23.7315 3.3556 23.6959 3.36708 23.6595 3.36686H13.992C13.737 3.36621 13.4863 3.43283 13.2652 3.56C13.0441 3.68718 12.8604 3.8704 12.7328 4.09121L11.4649 6.28474L9.22361 10.1676C9.09479 10.3927 8.9002 10.573 8.66595 10.6843C8.43171 10.7956 8.16901 10.8327 7.91312 10.7904C6.61799 10.5754 5.19659 10.7238 3.76154 11.3433C2.6524 11.8202 1.30608 13.0931 0.783077 14.1784C-1.663 19.2582 1.97753 24.2579 6.7801 24.2579C7.55122 24.2586 8.31676 24.1273 9.04359 23.8697C9.08144 23.8556 9.12305 23.8555 9.16101 23.8692C9.19897 23.883 9.23082 23.9097 9.25091 23.9448L11.9137 28.5562L13.1815 30.7532C13.3088 30.9736 13.4919 31.1567 13.7123 31.284C13.9328 31.4113 14.1828 31.4783 14.4374 31.4784H22.4744C22.5107 31.4783 22.5461 31.4899 22.5754 31.5114C22.6048 31.5329 22.6264 31.5631 22.6373 31.5978C22.9161 32.4416 23.3788 33.213 23.9919 33.8562C24.605 34.4994 25.3533 34.9985 26.1828 35.3174C27.0122 35.6362 27.9022 35.767 28.7883 35.7001C29.6744 35.6332 30.5346 35.3704 31.3068 34.9306C32.079 34.4908 32.7439 33.8851 33.2536 33.1571C33.7632 32.4291 34.1048 31.5971 34.2537 30.721C34.4027 29.8449 34.3552 28.9467 34.1148 28.0912C33.8744 27.2357 33.4471 26.4442 32.8636 25.774C32.8395 25.7471 32.8246 25.7134 32.8209 25.6775C32.8172 25.6416 32.825 25.6055 32.8431 25.5743L35.6868 20.6472L36.9563 18.4511C37.0838 18.2305 37.1509 17.9803 37.1509 17.7255C37.1509 17.4707 37.0838 17.2204 36.9563 16.9999ZM26.7215 3.79601C27.2181 2.95477 28.3562 2.53927 29.4654 3.21925C29.5874 3.2936 29.6931 3.39201 29.7759 3.50848C30.1931 4.10571 30.2682 4.68758 30.1436 5.19181C30.0781 5.45051 29.9577 5.69212 29.7908 5.90035C29.6239 6.10858 29.4143 6.27858 29.176 6.39888C28.9378 6.51918 28.6765 6.58697 28.4099 6.59769C28.1432 6.60841 27.8774 6.5618 27.6302 6.46101C27.3831 6.36021 27.1605 6.20759 26.9774 6.01342C26.7943 5.81926 26.655 5.58808 26.5689 5.33548C26.4828 5.08289 26.4518 4.81475 26.4781 4.54918C26.5045 4.28361 26.5875 4.02677 26.7215 3.79601ZM10.7389 18.1295C10.6109 18.8999 10.2614 19.6165 9.73316 20.1917C9.20489 20.767 8.52061 21.176 7.76382 21.369C6.84153 21.6036 5.79552 21.5081 4.74611 21.0013C4.16358 20.7188 3.68261 20.2632 3.36907 19.6968C1.66271 16.5997 3.85197 13.4626 6.7818 13.4626C6.9562 13.4619 7.13042 13.4739 7.3031 13.4984C7.99056 13.5858 8.64307 13.8521 9.19546 14.2705C9.44172 14.4558 9.66587 14.6688 9.8635 14.9053C10.3089 15.4369 10.6075 16.0757 10.7295 16.7584C10.7735 16.9953 10.7955 17.2358 10.7952 17.4768C10.7955 17.6964 10.7767 17.9157 10.7389 18.132V18.1295ZM11.5118 12.6179L11.5076 12.6136C11.4482 12.5561 11.4097 12.4803 11.3983 12.3984C11.3868 12.3165 11.4031 12.2331 11.4444 12.1615L14.4186 7.0108C14.5459 6.79005 14.729 6.60673 14.9497 6.47927C15.1703 6.35181 15.4206 6.28471 15.6754 6.28474H21.756C21.831 6.28487 21.9039 6.30972 21.9634 6.35543C22.0229 6.40115 22.0656 6.46518 22.085 6.53764C22.1045 6.61009 22.0995 6.68693 22.0708 6.75627C22.0422 6.8256 21.9915 6.88357 21.9266 6.92121L11.9555 12.6751C11.886 12.7159 11.805 12.7329 11.7249 12.7235C11.6449 12.7141 11.57 12.6788 11.5118 12.623V12.6179ZM21.6707 28.5562H16.125C15.8703 28.5563 15.62 28.4894 15.3994 28.3621C15.1788 28.2348 14.9956 28.0516 14.8683 27.831L12.2516 23.2989C12.2046 23.2176 12.1858 23.123 12.1981 23.0299C12.2103 22.9368 12.253 22.8504 12.3194 22.784C12.3858 22.7176 12.4722 22.675 12.5653 22.6627C12.6584 22.6504 12.753 22.6692 12.8343 22.7162L21.8328 27.9112C21.9016 27.9464 21.9565 28.004 21.9884 28.0744C22.0202 28.1449 22.0272 28.2241 22.0082 28.299C21.9891 28.374 21.9452 28.4403 21.8836 28.487C21.822 28.5337 21.7463 28.5581 21.669 28.5562H21.6707ZM23.9657 25.6102C23.9395 25.6393 23.9041 25.6584 23.8654 25.6645C23.8267 25.6705 23.7872 25.6631 23.7533 25.6434L13.7992 19.8981C13.6417 19.8069 13.5175 19.6677 13.4447 19.5008C13.372 19.334 13.3545 19.1482 13.3948 18.9707C13.6186 17.9681 13.6143 16.9281 13.382 15.9274C13.3402 15.7491 13.3569 15.5621 13.4295 15.394C13.5022 15.2259 13.627 15.0857 13.7856 14.994L24.7694 8.65061C24.9076 8.57093 25.0653 8.53157 25.2247 8.537C25.3842 8.54243 25.5388 8.59243 25.6713 8.68133C25.8943 8.83287 26.1301 8.96476 26.376 9.0755C26.5252 9.14316 26.6518 9.25236 26.7406 9.39004C26.8294 9.52772 26.8767 9.68806 26.8768 9.8519V23.7588C26.8769 23.7966 26.8643 23.8335 26.8412 23.8634C26.818 23.8934 26.7855 23.9148 26.7488 23.9243C25.6821 24.2174 24.7177 24.8011 23.9632 25.6102H23.9657ZM28.3409 32.8776C27.5026 32.8776 26.6987 32.5446 26.106 31.9519C25.5132 31.3591 25.1803 30.5552 25.1803 29.717C25.1803 28.8787 25.5132 28.0748 26.106 27.4821C26.6987 26.8893 27.5026 26.5564 28.3409 26.5564C28.5208 26.5564 28.7003 26.5721 28.8775 26.6033C29.6656 26.7283 30.3771 27.1471 30.8689 27.7754C31.3608 28.4038 31.5964 29.1951 31.5284 29.9901C31.4604 30.7851 31.0938 31.5249 30.5024 32.0607C29.911 32.5964 29.1387 32.8882 28.3409 32.8776ZM33.5845 18.4494L30.5071 23.781C30.4629 23.8574 30.3943 23.9168 30.3123 23.9496C30.2303 23.9824 30.1397 23.9867 30.0549 23.9618H30.0489C29.9774 23.9406 29.9146 23.8969 29.87 23.837C29.8254 23.7772 29.8014 23.7046 29.8015 23.6299V11.7332C29.7988 11.6559 29.8224 11.5799 29.8684 11.5178C29.9145 11.4556 29.9803 11.411 30.0551 11.3911C30.1298 11.3713 30.2091 11.3775 30.2799 11.4086C30.3508 11.4397 30.4089 11.494 30.4448 11.5625L33.5845 17.0016C33.711 17.222 33.7773 17.4717 33.7768 17.7258C33.7764 17.9799 33.7092 18.2295 33.582 18.4494H33.5845Z"
        fill="#4447E2"
      />
      <path
        d="M52.0495 20.2163V6.39478C52.0488 6.34349 52.0583 6.29257 52.0775 6.24498C52.0966 6.19739 52.1251 6.15409 52.1611 6.11757C52.1971 6.08106 52.2401 6.05207 52.2874 6.03229C52.3347 6.0125 52.3855 6.00232 52.4368 6.00232H55.603C55.6544 6.0022 55.7053 6.0123 55.7528 6.03203C55.8003 6.05175 55.8434 6.08071 55.8795 6.11722C55.9157 6.15373 55.9443 6.19707 55.9636 6.24472C55.9829 6.29237 55.9926 6.34338 55.992 6.39478V20.2163C55.992 20.3193 55.9511 20.418 55.8783 20.4908C55.8055 20.5636 55.7068 20.6045 55.6038 20.6045H52.4368C52.334 20.6043 52.2355 20.5633 52.1629 20.4905C52.0903 20.4178 52.0495 20.3191 52.0495 20.2163Z"
        fill="#4447E2"
      />
      <path
        d="M79.1269 20.2163V11.9149C79.1271 11.828 79.0981 11.7436 79.0446 11.6752C78.9911 11.6067 78.9162 11.5582 78.8318 11.5373C78.7475 11.5165 78.6586 11.5246 78.5794 11.5602C78.5002 11.5959 78.4352 11.6571 78.3949 11.734L73.8167 20.3964C73.7839 20.4586 73.7349 20.5108 73.6748 20.5473C73.6146 20.5838 73.5458 20.6033 73.4754 20.6037H70.1582C70.0879 20.6033 70.019 20.5838 69.9589 20.5473C69.8988 20.5108 69.8497 20.4586 69.817 20.3964L65.2345 11.7331C65.194 11.6567 65.129 11.5959 65.05 11.5606C64.9709 11.5252 64.8824 11.5173 64.7983 11.5381C64.7143 11.5589 64.6396 11.6072 64.5862 11.6753C64.5327 11.7434 64.5036 11.8274 64.5034 11.914V20.2163C64.5034 20.3193 64.4625 20.418 64.3897 20.4908C64.3169 20.5636 64.2181 20.6045 64.1152 20.6045H60.9498C60.8469 20.6045 60.7482 20.5636 60.6754 20.4908C60.6025 20.418 60.5616 20.3193 60.5616 20.2163V6.39478C60.5615 6.34377 60.5715 6.29324 60.591 6.24609C60.6104 6.19894 60.639 6.1561 60.6751 6.12003C60.7112 6.08396 60.754 6.05537 60.8012 6.03591C60.8483 6.01644 60.8988 6.00647 60.9498 6.00658H65.6842C65.7543 6.00673 65.8231 6.02593 65.8833 6.06215C65.9434 6.09837 65.9925 6.15023 66.0254 6.2122L71.4713 16.4163C71.5046 16.4777 71.5539 16.529 71.614 16.5648C71.674 16.6006 71.7427 16.6194 71.8126 16.6194C71.8825 16.6194 71.9511 16.6006 72.0112 16.5648C72.0712 16.529 72.1205 16.4777 72.1538 16.4163L77.6057 6.20794C77.6385 6.1459 77.6877 6.09399 77.7478 6.05776C77.8079 6.02154 77.8768 6.00237 77.9469 6.00232H82.6608C82.712 6.00243 82.7628 6.01269 82.8101 6.03252C82.8573 6.05234 82.9002 6.08134 82.9362 6.11783C82.9723 6.15432 83.0007 6.19758 83.0199 6.24511C83.0391 6.29265 83.0487 6.34352 83.0481 6.39478V20.2163C83.0481 20.3193 83.0072 20.418 82.9344 20.4908C82.8616 20.5636 82.7629 20.6045 82.6599 20.6045H79.5151C79.4121 20.6045 79.3134 20.5636 79.2406 20.4908C79.1678 20.418 79.1269 20.3193 79.1269 20.2163Z"
        fill="#4447E2"
      />
      <path
        d="M101.068 9.51745C101.068 9.58135 101.052 9.64427 101.022 9.70062C100.992 9.75697 100.949 9.805 100.895 9.84045C100.842 9.8759 100.781 9.89767 100.717 9.90383C100.654 9.91 100.59 9.90036 100.531 9.87578C100.36 9.80667 100.177 9.73415 99.9736 9.65737C99.5185 9.48673 99.0049 9.32576 98.4327 9.17447C97.8167 9.01327 97.1924 8.88539 96.5625 8.79139C95.8766 8.68806 95.1838 8.63673 94.4902 8.63781C93.9214 8.63781 93.4379 8.65545 93.0397 8.69071C92.701 8.71794 92.364 8.76408 92.0304 8.82893C91.8076 8.86988 91.5901 8.9357 91.382 9.02516C91.2493 9.08319 91.1257 9.16021 91.0151 9.25381C90.941 9.31619 90.8842 9.39674 90.8505 9.48758C90.8273 9.5561 90.8146 9.62772 90.8129 9.70003C90.8129 9.91275 90.9193 10.0987 91.132 10.258C91.3983 10.4448 91.6923 10.5888 92.0031 10.6846C92.4257 10.8238 92.8551 10.9411 93.2897 11.0361C93.7789 11.1453 94.2976 11.2591 94.8459 11.3774C95.3942 11.4957 95.961 11.6231 96.5463 11.7596C97.131 11.8978 97.6978 12.0591 98.2467 12.2434C98.7802 12.421 99.3005 12.6359 99.8038 12.8867C100.268 13.114 100.7 13.4008 101.09 13.7398C101.45 14.0559 101.746 14.4386 101.961 14.8669C102.18 15.3202 102.289 15.8189 102.28 16.3224C102.28 17.0237 102.156 17.6261 101.908 18.1295C101.67 18.6193 101.331 19.0535 100.915 19.4041C100.484 19.7604 99.9976 20.0424 99.4744 20.2385C98.9178 20.4506 98.3433 20.6125 97.7578 20.7223C97.1575 20.8358 96.5505 20.9105 95.9406 20.9458C95.328 20.9805 94.7453 20.9982 94.1924 20.9987C92.8475 21.0076 91.5048 20.8885 90.1824 20.6429C89.1653 20.4536 88.1638 20.1886 87.1861 19.8503C87.1108 19.823 87.0459 19.773 87.0001 19.7074C86.9543 19.6417 86.9298 19.5635 86.9301 19.4835V16.906C86.9301 16.8402 86.9469 16.7755 86.9788 16.718C87.0107 16.6604 87.0567 16.6119 87.1125 16.577C87.1683 16.5421 87.232 16.522 87.2977 16.5185C87.3634 16.515 87.4289 16.5283 87.4881 16.5571C88.372 16.9787 89.298 17.3056 90.2507 17.5322C91.5582 17.8445 92.8985 17.9981 94.2427 17.9895C94.9277 18.0002 95.6125 17.9557 96.2904 17.8565C96.7159 17.7958 97.1319 17.6812 97.5283 17.5152C97.8264 17.377 98.0283 17.2262 98.1341 17.063C98.2319 16.9261 98.2874 16.7636 98.2936 16.5954C98.2917 16.4758 98.2619 16.3583 98.2065 16.2522C98.1511 16.1461 98.0717 16.0545 97.9746 15.9846C97.7118 15.7845 97.4174 15.6299 97.1035 15.5273C96.6823 15.3818 96.253 15.2613 95.8177 15.1664C95.3285 15.056 94.8095 14.9462 94.2606 14.837C93.7118 14.7278 93.1467 14.609 92.5654 14.4804C91.9846 14.3536 91.4195 14.2031 90.8701 14.0291C90.3384 13.8623 89.8184 13.6599 89.3139 13.4233C88.8503 13.2095 88.4176 12.9343 88.0273 12.6051C87.666 12.3026 87.368 11.9318 87.1502 11.5139C86.9301 11.0663 86.8206 10.5724 86.8311 10.0737C86.8311 9.42985 86.9449 8.87386 87.1724 8.40575C87.3923 7.94801 87.7052 7.54119 88.0913 7.21129C88.4917 6.87363 88.944 6.60282 89.4308 6.4093C89.9476 6.20032 90.4829 6.04036 91.0296 5.93152C91.591 5.81772 92.1589 5.73935 92.73 5.69689C93.3045 5.65537 93.8503 5.63433 94.3673 5.63376C94.9361 5.63376 95.5188 5.6622 96.1155 5.71908C96.7121 5.77596 97.3017 5.85587 97.8841 5.95882C98.4649 6.0612 99.0265 6.1798 99.5692 6.3146C100.004 6.42267 100.414 6.53643 100.797 6.65587C100.877 6.68002 100.946 6.72912 100.996 6.79595C101.046 6.86277 101.072 6.94377 101.072 7.02701L101.068 9.51745Z"
        fill="#4447E2"
      />
      <path
        d="M124.909 13.3133C124.909 14.5646 124.678 15.6718 124.218 16.6347C123.764 17.5857 123.086 18.4118 122.241 19.0415C121.383 19.6865 120.343 20.1737 119.122 20.503C117.9 20.8324 116.527 20.997 115.004 20.997C113.48 20.997 112.104 20.8324 110.876 20.503C109.647 20.1737 108.6 19.6865 107.735 19.0415C106.884 18.4123 106.198 17.5858 105.737 16.633C105.269 15.6735 105.036 14.5663 105.036 13.3116C105.036 12.0568 105.269 10.95 105.737 9.99098C106.199 9.04053 106.884 8.21638 107.735 7.58927C108.599 6.94427 109.646 6.4571 110.876 6.12777C112.105 5.79844 113.481 5.6315 115.004 5.62695C116.527 5.62695 117.9 5.79162 119.122 6.12095C120.343 6.45027 121.383 6.93972 122.241 7.58927C123.086 8.21873 123.764 9.04491 124.218 9.9961C124.678 10.9511 124.909 12.0568 124.909 13.3133ZM120.923 13.3133C120.922 12.7592 120.834 12.2088 120.662 11.682C120.48 11.126 120.163 10.624 119.738 10.2213C119.296 9.78906 118.692 9.43812 117.926 9.16851C117.161 8.89891 116.187 8.76439 115.004 8.76496C114.302 8.75785 113.6 8.82131 112.91 8.95437C112.37 9.05717 111.845 9.22922 111.348 9.46627C110.94 9.66211 110.566 9.92127 110.239 10.2341C109.682 10.7748 109.302 11.4714 109.15 12.2323C109.076 12.5871 109.039 12.9484 109.038 13.3107C109.039 13.6784 109.076 14.0451 109.15 14.4053C109.224 14.7743 109.351 15.1306 109.527 15.4633C109.714 15.8114 109.954 16.1281 110.239 16.4018C110.566 16.7125 110.94 16.9689 111.348 17.1611C111.845 17.3973 112.37 17.5694 112.91 17.673C113.6 17.8054 114.302 17.8677 115.004 17.859C116.187 17.859 117.161 17.7245 117.926 17.4555C118.692 17.1864 119.296 16.8358 119.738 16.4035C120.163 16.0005 120.48 15.4983 120.662 14.942C120.834 14.416 120.922 13.8665 120.923 13.3133Z"
        fill="#4447E2"
      />
      <path
        d="M132.443 9.50379V11.2673C132.443 11.3703 132.484 11.469 132.557 11.5418C132.63 11.6146 132.728 11.6555 132.831 11.6555H141.545C141.648 11.6555 141.747 11.6964 141.819 11.7692C141.892 11.842 141.933 11.9408 141.933 12.0437V14.3814C141.933 14.4844 141.892 14.5831 141.819 14.6559C141.747 14.7287 141.648 14.7696 141.545 14.7696H132.831C132.728 14.7696 132.63 14.8105 132.557 14.8833C132.484 14.9561 132.443 15.0549 132.443 15.1578V20.2163C132.443 20.3193 132.402 20.418 132.329 20.4908C132.257 20.5636 132.158 20.6045 132.055 20.6045H128.889C128.786 20.6045 128.687 20.5636 128.614 20.4908C128.541 20.418 128.501 20.3193 128.501 20.2163V6.39479C128.5 6.34378 128.51 6.29325 128.53 6.2461C128.549 6.19895 128.578 6.15611 128.614 6.12004C128.65 6.08397 128.693 6.05538 128.74 6.03591C128.787 6.01644 128.838 6.00648 128.889 6.00659H142.065C142.168 6.00659 142.267 6.04749 142.34 6.12029C142.413 6.19309 142.453 6.29183 142.453 6.39479V8.73166C142.453 8.83461 142.413 8.93335 142.34 9.00616C142.267 9.07896 142.168 9.11986 142.065 9.11986H132.831C132.729 9.11985 132.631 9.16016 132.558 9.23204C132.486 9.30393 132.444 9.40157 132.443 9.50379Z"
        fill="#4447E2"
      />
      <path
        d="M154.006 9.56778V20.2163C154.005 20.3194 153.964 20.4181 153.891 20.4909C153.818 20.5637 153.72 20.6045 153.617 20.6045H150.451C150.348 20.6045 150.249 20.5637 150.176 20.4909C150.104 20.4181 150.062 20.3194 150.062 20.2163V9.56778C150.062 9.46482 150.021 9.36608 149.949 9.29328C149.876 9.22048 149.777 9.17958 149.674 9.17958H144.255C144.152 9.17958 144.054 9.13868 143.981 9.06588C143.908 8.99308 143.867 8.89434 143.867 8.79138V6.39479C143.867 6.29183 143.908 6.19309 143.981 6.12029C144.054 6.04749 144.152 6.00659 144.255 6.00659H159.823C159.926 6.00659 160.025 6.04749 160.098 6.12029C160.171 6.19309 160.212 6.29183 160.212 6.39479V8.79565C160.212 8.8986 160.171 8.99734 160.098 9.07014C160.025 9.14294 159.926 9.18384 159.823 9.18384H154.392C154.29 9.18429 154.193 9.2248 154.12 9.29663C154.048 9.36846 154.007 9.46586 154.006 9.56778Z"
        fill="#4447E2"
      />
      <path
        d="M55.5799 24.8637C56.0351 24.8609 56.4895 24.9026 56.9365 24.9882C57.2896 25.0572 57.6375 25.151 57.9774 25.2689C58.0095 25.2798 58.0374 25.3005 58.0571 25.328C58.0768 25.3556 58.0875 25.3886 58.0874 25.4225V26.256C58.0875 26.2834 58.0806 26.3103 58.0674 26.3342C58.0543 26.3581 58.0353 26.3784 58.0122 26.393C57.9891 26.4077 57.9627 26.4162 57.9355 26.4179C57.9082 26.4197 57.881 26.4144 57.8562 26.4028C57.7829 26.3678 57.7044 26.3328 57.6233 26.2987C57.4404 26.2214 57.2525 26.1561 57.0611 26.1033C56.8473 26.0455 56.6302 26.0011 56.4109 25.9702C56.1691 25.9354 55.925 25.9183 55.6806 25.919C55.4021 25.9156 55.1238 25.9388 54.8496 25.9881C54.6405 26.025 54.4365 26.0869 54.2422 26.1724C54.0899 26.2387 53.9495 26.3295 53.8267 26.4412C53.7243 26.5359 53.6378 26.6465 53.5707 26.7688C53.5093 26.8795 53.4653 26.9989 53.4402 27.1229C53.4168 27.2383 53.4048 27.3558 53.4043 27.4735C53.4052 27.5812 53.4155 27.6885 53.435 27.7943C53.457 27.9149 53.4957 28.0318 53.5502 28.1416C53.6119 28.2639 53.6919 28.3761 53.7874 28.4743C53.9022 28.5902 54.0361 28.6854 54.1833 28.7559C54.3699 28.846 54.5671 28.9122 54.7703 28.953C55.0391 29.0063 55.3128 29.0311 55.5868 29.0272C55.7455 29.0272 55.8845 29.0221 56.0023 29.0127C56.12 29.0033 56.2284 28.9896 56.3256 28.9726C56.4182 28.9567 56.5099 28.9362 56.6004 28.9112L56.748 28.8693C56.7819 28.8597 56.8118 28.8392 56.833 28.811C56.8543 28.7829 56.8657 28.7485 56.8657 28.7132V28.3975C56.8656 28.3763 56.8613 28.3552 56.853 28.3356C56.8448 28.3159 56.8327 28.2981 56.8176 28.2832C56.8025 28.2682 56.7845 28.2563 56.7648 28.2483C56.7451 28.2403 56.724 28.2362 56.7027 28.2363H55.5245C55.4816 28.2361 55.4405 28.2189 55.4101 28.1886C55.3798 28.1582 55.3626 28.1171 55.3624 28.0742V27.3106C55.3626 27.2677 55.3798 27.2266 55.4101 27.1962C55.4405 27.1659 55.4816 27.1487 55.5245 27.1485H58.0448C58.0878 27.1485 58.129 27.1656 58.1594 27.196C58.1898 27.2264 58.2069 27.2676 58.2069 27.3106V29.5673C58.2068 29.6019 58.1957 29.6357 58.1752 29.6636C58.1546 29.6915 58.1257 29.7122 58.0926 29.7225C57.945 29.7686 57.7829 29.8078 57.6088 29.8497C57.3878 29.8991 57.1609 29.9418 56.9263 29.9768C56.6916 30.0118 56.4562 30.0382 56.2198 30.0578C55.9835 30.0775 55.7608 30.0868 55.5518 30.0868C55.2378 30.0877 54.9241 30.0657 54.6133 30.0211C54.3285 29.9815 54.0482 29.9144 53.7763 29.8206C53.5271 29.7365 53.2892 29.6219 53.0682 29.4794C52.8601 29.3443 52.6759 29.1756 52.523 28.9803C52.3685 28.7813 52.2498 28.557 52.1723 28.3173C52.0856 28.0461 52.0436 27.7625 52.0478 27.4778C52.0437 27.193 52.0876 26.9095 52.1775 26.6391C52.2592 26.3982 52.3822 26.1733 52.5409 25.9745C52.6993 25.779 52.8883 25.6105 53.1006 25.4754C53.326 25.3336 53.5675 25.2191 53.8198 25.1341C54.0924 25.0407 54.3732 24.9735 54.6585 24.9336C54.9635 24.8879 55.2715 24.8645 55.5799 24.8637Z"
        fill="#4447E2"
      />
      <path
        d="M73.9558 29.9588H72.9388C72.8958 29.9588 72.8545 29.9418 72.8241 29.9114C72.7937 29.881 72.7767 29.8397 72.7767 29.7967V25.1563C72.7767 25.1133 72.7937 25.072 72.8241 25.0416C72.8545 25.0112 72.8958 24.9942 72.9388 24.9942H76.1374C76.4477 24.9878 76.7573 25.0254 77.0571 25.1059C77.2822 25.1669 77.4917 25.2754 77.6714 25.4242C77.8257 25.5578 77.9432 25.7288 78.0127 25.9207C78.0864 26.1288 78.1225 26.3484 78.1193 26.5691C78.1241 26.7559 78.0952 26.942 78.034 27.1186C77.9798 27.2664 77.8988 27.4029 77.7951 27.5213C77.6949 27.6343 77.5771 27.7302 77.4461 27.8054C77.3762 27.8464 77.3037 27.883 77.2294 27.9172C77.2065 27.9273 77.1862 27.9425 77.1701 27.9618C77.1541 27.981 77.1427 28.0038 77.1369 28.0281C77.1311 28.0525 77.1311 28.0779 77.1368 28.1024C77.1425 28.1268 77.1537 28.1495 77.1697 28.1689L78.4333 29.6935C78.4528 29.7172 78.4653 29.7459 78.4691 29.7764C78.473 29.8069 78.4681 29.8378 78.455 29.8656C78.442 29.8934 78.4213 29.9169 78.3954 29.9334C78.3695 29.95 78.3394 29.9588 78.3087 29.9588H77.1612C77.1372 29.959 77.1135 29.9537 77.0918 29.9436C77.0701 29.9334 77.051 29.9185 77.0358 29.9L75.6297 28.1893C75.6143 28.171 75.5952 28.1562 75.5735 28.1461C75.5518 28.1359 75.5282 28.1306 75.5043 28.1305H74.2783C74.2353 28.1305 74.194 28.1475 74.1636 28.1779C74.1332 28.2083 74.1162 28.2496 74.1162 28.2926V29.7967C74.1159 29.8394 74.099 29.8802 74.069 29.9105C74.0391 29.9408 73.9984 29.9582 73.9558 29.9588ZM76.7661 26.5623C76.7681 26.4788 76.7554 26.3957 76.7286 26.3166C76.703 26.2491 76.6567 26.1915 76.5964 26.1519C76.5198 26.1047 76.4345 26.0734 76.3455 26.0598C76.2158 26.0388 76.0845 26.0291 75.9531 26.0308H74.2783C74.2353 26.0308 74.194 26.0479 74.1636 26.0783C74.1332 26.1087 74.1162 26.1499 74.1162 26.1929V26.9317C74.1162 26.9747 74.1332 27.016 74.1636 27.0464C74.194 27.0768 74.2353 27.0938 74.2783 27.0938H75.9514C76.0828 27.0955 76.2141 27.0858 76.3438 27.0648C76.4328 27.0512 76.5181 27.0199 76.5947 26.9727C76.655 26.9332 76.7013 26.8755 76.7269 26.808C76.7542 26.729 76.7675 26.6459 76.7661 26.5623Z"
        fill="#4447E2"
      />
      <path
        d="M100.262 27.4769C100.27 27.8661 100.189 28.2519 100.027 28.6057C99.8734 28.9293 99.6426 29.2102 99.355 29.4239C99.0364 29.6558 98.6765 29.8246 98.2945 29.9213C97.3731 30.1454 96.4115 30.1454 95.4901 29.9213C95.1059 29.8248 94.7437 29.656 94.4228 29.4239C94.1321 29.2107 93.8979 28.9298 93.7402 28.6057C93.5833 28.2499 93.5022 27.8654 93.5022 27.4765C93.5022 27.0877 93.5833 26.7031 93.7402 26.3473C93.8979 26.0232 94.1321 25.7424 94.4228 25.5291C94.7437 25.2971 95.1059 25.1282 95.4901 25.0317C96.4115 24.8076 97.3731 24.8076 98.2945 25.0317C98.6765 25.1284 99.0364 25.2972 99.355 25.5291C99.6424 25.7431 99.8732 26.0239 100.027 26.3473C100.189 26.7014 100.27 27.0876 100.262 27.4769ZM98.9071 27.4769C98.9076 27.2885 98.8788 27.1011 98.8218 26.9215C98.7598 26.7326 98.6519 26.562 98.5078 26.425C98.3305 26.2625 98.12 26.1406 97.8909 26.0675C97.5699 25.9667 97.2342 25.9203 96.8978 25.9301C96.6588 25.927 96.4201 25.9481 96.1854 25.9933C96.0017 26.0284 95.8233 26.0872 95.6548 26.1682C95.5165 26.2354 95.3895 26.3238 95.2785 26.4301C95.0884 26.6145 94.9592 26.8527 94.9082 27.1126C94.8832 27.2333 94.8706 27.3563 94.8707 27.4795C94.8706 27.6045 94.8832 27.7291 94.9082 27.8515C94.9338 27.9766 94.9769 28.0976 95.0362 28.2107C95.1 28.3292 95.1818 28.4371 95.2785 28.5306C95.3897 28.6352 95.5167 28.7216 95.6548 28.7866C95.8237 28.8657 96.002 28.9231 96.1854 28.9572C96.4201 29.0024 96.6588 29.0235 96.8978 29.0204C97.2342 29.0302 97.5699 28.9838 97.8909 28.883C98.12 28.8099 98.3305 28.6879 98.5078 28.5255C98.6519 28.3885 98.7598 28.2179 98.8218 28.029C98.8785 27.8505 98.9073 27.6642 98.9071 27.4769Z"
        fill="#4447E2"
      />
      <path
        d="M119.946 28.9188C119.81 29.1516 119.62 29.3484 119.393 29.493C119.11 29.6733 118.799 29.8051 118.473 29.8829C117.624 30.074 116.742 30.074 115.893 29.8829C115.566 29.8063 115.254 29.675 114.97 29.4947C114.742 29.3501 114.553 29.1533 114.417 28.9205C114.296 28.7067 114.232 28.465 114.233 28.2192V25.0889C114.233 25.0459 114.25 25.0048 114.281 24.9745C114.311 24.9441 114.352 24.927 114.395 24.9268H115.408C115.451 24.927 115.492 24.9441 115.522 24.9745C115.552 25.0048 115.569 25.0459 115.57 25.0889V27.7388C115.569 27.898 115.59 28.0566 115.633 28.2098C115.675 28.3589 115.757 28.4935 115.871 28.5989C116.012 28.7233 116.18 28.8135 116.362 28.8625C116.63 28.9346 116.907 28.9674 117.185 28.9598C117.46 28.9672 117.735 28.9345 118.001 28.8625C118.183 28.8133 118.35 28.7231 118.491 28.5989C118.604 28.4936 118.686 28.3589 118.727 28.2098C118.769 28.0563 118.79 27.8979 118.789 27.7388V25.0889C118.789 25.0459 118.806 25.0048 118.837 24.9745C118.867 24.9441 118.908 24.927 118.951 24.9268H119.968C120.011 24.927 120.052 24.9441 120.082 24.9745C120.113 25.0048 120.13 25.0459 120.13 25.0889V28.2192C120.13 28.4644 120.067 28.7055 119.946 28.9188Z"
        fill="#4447E2"
      />
      <path
        d="M140.54 26.6886C140.542 26.9205 140.505 27.1512 140.431 27.3711C140.361 27.5764 140.241 27.7612 140.083 27.9095C139.903 28.0709 139.69 28.1911 139.459 28.2619C139.157 28.3529 138.842 28.3955 138.526 28.3881H136.463C136.42 28.3881 136.379 28.4052 136.348 28.4356C136.318 28.4659 136.301 28.5072 136.3 28.5502V29.7942C136.3 29.8372 136.283 29.8784 136.253 29.9088C136.222 29.9392 136.181 29.9563 136.138 29.9563H135.122C135.079 29.9563 135.038 29.9392 135.008 29.9088C134.977 29.8784 134.96 29.8372 134.96 29.7942V25.1563C134.96 25.1133 134.977 25.072 135.008 25.0416C135.038 25.0112 135.079 24.9942 135.122 24.9942H138.523C138.838 24.9871 139.153 25.0292 139.455 25.1187C139.687 25.1879 139.9 25.3077 140.079 25.4694C140.238 25.617 140.357 25.8013 140.428 26.006C140.503 26.2257 140.541 26.4564 140.54 26.6886ZM139.184 26.7108C139.187 26.6091 139.17 26.5078 139.136 26.4122C139.103 26.3298 139.048 26.2589 138.975 26.2082C138.886 26.1497 138.787 26.1097 138.682 26.0905C138.536 26.0633 138.387 26.0508 138.238 26.053H136.463C136.42 26.053 136.379 26.07 136.348 26.1004C136.318 26.1308 136.301 26.172 136.3 26.2151V27.1698C136.301 27.2129 136.318 27.2541 136.348 27.2845C136.379 27.3148 136.42 27.3319 136.463 27.3319H138.238C138.387 27.3338 138.535 27.3236 138.682 27.3012C138.786 27.2867 138.886 27.251 138.975 27.1962C139.047 27.1498 139.103 27.0826 139.136 27.0034C139.17 26.9099 139.187 26.8105 139.184 26.7108Z"
        fill="#4447E2"
      />
    </svg>
  );
}

function MainIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 9.999V17C20 17.2652 19.8946 17.5196 19.7071 17.7071C19.5196 17.8946 19.2652 18 19 18H11V9.999H20ZM9 9.999V18H1C0.734784 18 0.48043 17.8946 0.292893 17.7071C0.105357 17.5196 0 17.2652 0 17V9.999H9ZM9 0V7.999H0V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H9ZM19 0C19.2652 0 19.5196 0.105357 19.7071 0.292893C19.8946 0.48043 20 0.734784 20 1V7.999H11V0H19Z"
        fill="#262631"
      />
    </svg>
  );
}

function ProfileIconDiagrammIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 2.05V13H21.95C21.449 18.053 17.185 22 12 22C6.477 22 2 17.523 2 12C2 6.815 5.947 2.551 11 2.05ZM13 0.542999C18.553 1.02 22.979 5.447 23.457 11H13V0.542999Z"
        fill="white"
      />
    </svg>
  );
}

function GlobusIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM16.355 13.952V13.847C16.355 12.925 16.355 12.504 15.703 12.131C15.4934 12.0122 15.2782 11.9037 15.058 11.806C14.691 11.639 14.448 11.53 14.12 11.05C14.0808 10.993 14.0422 10.9357 14.004 10.878C13.659 10.353 13.41 9.975 12.462 10.125C10.597 10.421 10.459 10.749 10.377 11.303L10.364 11.394C10.243 12.204 10.221 12.476 10.559 12.831C11.824 14.158 12.582 15.115 12.812 15.675C12.924 15.948 13.212 16.775 13.014 17.593C14.2278 17.1095 15.3083 16.3425 16.165 15.356C16.275 14.982 16.355 14.516 16.355 13.952ZM10 1.833C7.683 1.833 5.59 2.799 4.104 4.349C4.281 4.472 4.435 4.645 4.541 4.883C4.745 5.34 4.745 5.811 4.745 6.228C4.745 6.556 4.745 6.868 4.85 7.093C4.994 7.401 5.616 7.533 6.165 7.647C6.362 7.689 6.564 7.731 6.748 7.782C7.254 7.922 7.646 8.377 7.959 8.742C8.089 8.893 8.282 9.116 8.379 9.172C8.429 9.136 8.59 8.961 8.669 8.674C8.731 8.454 8.713 8.26 8.624 8.154C8.064 7.494 8.095 6.224 8.268 5.755C8.54 5.016 9.39 5.071 10.012 5.111C10.244 5.126 10.462 5.141 10.626 5.12C11.248 5.042 11.44 4.095 11.575 3.91C11.867 3.51 12.761 2.907 13.315 2.535C12.2715 2.07099 11.142 1.83181 10 1.833Z"
        fill="#BAC8DC"
      />
    </svg>
  );
}

function GlobusIcon2() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.04999 13H7.52699C7.6981 16.1668 8.70754 19.2314 10.452 21.88C8.26692 21.5368 6.25718 20.4791 4.737 18.8725C3.21683 17.2658 2.27191 15.2007 2.04999 13ZM2.04999 11C2.27191 8.7993 3.21683 6.73417 4.737 5.12751C6.25718 3.52084 8.26692 2.46322 10.452 2.12C8.70754 4.76861 7.6981 7.83314 7.52699 11H2.04999ZM21.95 11H16.473C16.3019 7.83314 15.2924 4.76861 13.548 2.12C15.7331 2.46322 17.7428 3.52084 19.263 5.12751C20.7832 6.73417 21.7281 8.7993 21.95 11ZM21.95 13C21.7281 15.2007 20.7832 17.2658 19.263 18.8725C17.7428 20.4791 15.7331 21.5368 13.548 21.88C15.2924 19.2314 16.3019 16.1668 16.473 13H21.951H21.95ZM9.52999 13H14.47C14.3054 15.6995 13.4553 18.3124 12 20.592C10.5447 18.3124 9.69458 15.6995 9.52999 13ZM9.52999 11C9.69458 8.30051 10.5447 5.68756 12 3.408C13.4553 5.68756 14.3054 8.30051 14.47 11H9.52999Z"
        fill="#BAC8DC"
      />
    </svg>
  );
}

function TelegramIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM8.89 13.17L8.903 13.163L9.773 16.033C9.885 16.344 10.039 16.4 10.226 16.374C10.414 16.349 10.513 16.248 10.636 16.13L11.824 14.982L14.374 16.87C14.84 17.127 15.175 16.994 15.291 16.438L16.948 8.616C17.131 7.888 16.811 7.596 16.246 7.828L6.513 11.588C5.849 11.854 5.853 12.226 6.393 12.391L8.89 13.171V13.17Z"
        fill="#BAC8DC"
      />
    </svg>
  );
}

function UsersIcon() {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="35.695px"
      height="35.695px"
      viewBox="0 0 35.695 35.695"
      style={{ enableBackground: "new 0 0 35.695 35.695" }}
    >
      <g>
        <path
          fill="#fff"
          d="M11.558,10.767c0-3.473,2.815-6.29,6.289-6.29c3.476,0,6.289,2.817,6.289,6.29c0,3.475-2.813,6.29-6.289,6.29
		C14.373,17.057,11.558,14.243,11.558,10.767z M35.667,22.607l-0.879-5.27c-0.158-0.954-0.961-1.754-1.896-1.984
		c-0.836,0.74-1.932,1.191-3.136,1.191c-1.203,0-2.3-0.452-3.135-1.191c-0.938,0.229-1.739,1.03-1.897,1.984l-0.021,0.124
		c-0.522-0.503-1.17-0.881-1.868-1.052c-1.33,1.176-3.072,1.896-4.987,1.896s-3.657-0.72-4.987-1.896
		c-0.698,0.171-1.346,0.549-1.868,1.052l-0.021-0.124c-0.158-0.954-0.962-1.754-1.897-1.984c-0.835,0.74-1.932,1.191-3.135,1.191
		c-1.204,0-2.3-0.452-3.136-1.191c-0.936,0.229-1.738,1.03-1.896,1.984l-0.879,5.27c-0.189,1.131,0.596,2.057,1.741,2.057h7.222
		l-0.548,3.283c-0.3,1.799,0.948,3.271,2.771,3.271H24.48c1.823,0,3.071-1.475,2.771-3.271l-0.548-3.283h7.222
		C35.071,24.662,35.855,23.738,35.667,22.607z M29.755,15.762c2.184,0,3.954-1.77,3.954-3.954c0-2.183-1.771-3.954-3.954-3.954
		s-3.953,1.771-3.953,3.954C25.802,13.992,27.574,15.762,29.755,15.762z M5.938,15.762c2.183,0,3.953-1.77,3.953-3.954
		c0-2.183-1.771-3.954-3.953-3.954c-2.184,0-3.954,1.771-3.954,3.954C1.984,13.992,3.755,15.762,5.938,15.762z"
        />
      </g>
    </svg>
  );
}

function ServiceIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.24864 2H12.7513C12.8565 1.99999 12.9602 2.02486 13.0539 2.0726C13.1477 2.12034 13.2288 2.18958 13.2906 2.27467L15.8393 5.77867C15.8846 5.84101 15.9069 5.91714 15.9024 5.99408C15.8979 6.07102 15.8669 6.14402 15.8146 6.20067L8.24463 14.4013C8.21343 14.4351 8.17558 14.462 8.13348 14.4804C8.09137 14.4988 8.04592 14.5083 7.99997 14.5083C7.95402 14.5083 7.90856 14.4988 7.86646 14.4804C7.82435 14.462 7.78651 14.4351 7.7553 14.4013L0.185302 6.20133C0.132869 6.14464 0.101745 6.07151 0.0972462 5.99442C0.0927473 5.91733 0.115153 5.84107 0.160635 5.77867L2.7093 2.27467C2.77116 2.18958 2.85227 2.12034 2.946 2.0726C3.03974 2.02486 3.14344 1.99999 3.24864 2Z"
        fill="black"
      />
    </svg>
  );
}

function CloseIconSmall() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 6 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.69736 3.31348L0.848682 1.46479L1.46491 0.848567L3.31359 2.69725L5.16227 0.848567L5.7785 1.46479L3.92982 3.31348L5.7785 5.16216L5.16227 5.77839L3.31359 3.9297L1.46491 5.77839L0.848682 5.16216L2.69736 3.31348Z"
        fill="white"
      />
    </svg>
  );
}

function CloseIcon() {
  return (
    <svg
      width="15px"
      height="15px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke="#641611"
        strokeWidth={"3"}
        d="M6.22566 4.81096C5.83514 4.42044 5.20197 4.42044 4.81145 4.81096C4.42092 5.20148 4.42092 5.83465 4.81145 6.22517L10.5862 11.9999L4.81151 17.7746C4.42098 18.1651 4.42098 18.7983 4.81151 19.1888C5.20203 19.5793 5.8352 19.5793 6.22572 19.1888L12.0004 13.4141L17.7751 19.1888C18.1656 19.5793 18.7988 19.5793 19.1893 19.1888C19.5798 18.7983 19.5798 18.1651 19.1893 17.7746L13.4146 11.9999L19.1893 6.22517C19.5799 5.83465 19.5799 5.20148 19.1893 4.81096C18.7988 4.42044 18.1657 4.42044 17.7751 4.81096L12.0004 10.5857L6.22566 4.81096Z"
        fill="#fff"
      />
    </svg>
  );
}

function CloseIconForTab() {
  return (
    <svg
      width="15px"
      height="15px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke="#888"
        fill="#888"
        strokeWidth={"1"}
        d="M6.22566 4.81096C5.83514 4.42044 5.20197 4.42044 4.81145 4.81096C4.42092 5.20148 4.42092 5.83465 4.81145 6.22517L10.5862 11.9999L4.81151 17.7746C4.42098 18.1651 4.42098 18.7983 4.81151 19.1888C5.20203 19.5793 5.8352 19.5793 6.22572 19.1888L12.0004 13.4141L17.7751 19.1888C18.1656 19.5793 18.7988 19.5793 19.1893 19.1888C19.5798 18.7983 19.5798 18.1651 19.1893 17.7746L13.4146 11.9999L19.1893 6.22517C19.5799 5.83465 19.5799 5.20148 19.1893 4.81096C18.7988 4.42044 18.1657 4.42044 17.7751 4.81096L12.0004 10.5857L6.22566 4.81096Z"
      />
    </svg>
  );
}

function DashIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="11px"
      height="3px"
      viewBox="0 0 52 52"
    >
      <path
        stroke="#15541f"
        strokeWidth="3"
        fill="#15541f"
        d="M50,27.5c0,0.8-0.7,1.5-1.5,1.5h-45C2.7,29,2,28.3,2,27.5v-3C2,23.7,2.7,23,3.5,23h45 c0.8,0,1.5,0.7,1.5,1.5V27.5z"
      />
    </svg>
  );
}

function ProfileIcon() {
  return (
    <svg
      width="12"
      height="15"
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 9.88045C9.25397 9.88045 12 10.4092 12 12.4492C12 14.49 9.23596 15 6 15C2.74678 15 0 14.4712 0 12.4312C0 10.3905 2.76404 9.88045 6 9.88045ZM6 0C8.20433 0 9.97049 1.76552 9.97049 3.96829C9.97049 6.17106 8.20433 7.93733 6 7.93733C3.79642 7.93733 2.02951 6.17106 2.02951 3.96829C2.02951 1.76552 3.79642 0 6 0Z"
        fill="black"
      />
    </svg>
  );
}

function VectorIcon() {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.125 13.9587C2.125 14.5222 2.34888 15.0627 2.7474 15.4613C3.14591 15.8598 3.68641 16.0837 4.25 16.0837H12.75C13.3136 16.0837 13.8541 15.8598 14.2526 15.4613C14.6511 15.0627 14.875 14.5222 14.875 13.9587V6.75349C14.8747 6.1902 14.6507 5.65007 14.2524 5.25183L11.5409 2.53891C11.1423 2.14063 10.6019 1.91692 10.0385 1.91699H4.25C3.68641 1.91699 3.14591 2.14088 2.7474 2.53939C2.34888 2.93791 2.125 3.47841 2.125 4.04199V13.9587ZM12.0417 8.29199C12.0417 8.10413 11.967 7.92396 11.8342 7.79113C11.7014 7.65829 11.5212 7.58366 11.3333 7.58366C11.1455 7.58366 10.9653 7.65829 10.8325 7.79113C10.6996 7.92396 10.625 8.10413 10.625 8.29199V12.542C10.625 12.7299 10.6996 12.91 10.8325 13.0429C10.9653 13.1757 11.1455 13.2503 11.3333 13.2503C11.5212 13.2503 11.7014 13.1757 11.8342 13.0429C11.967 12.91 12.0417 12.7299 12.0417 12.542V8.29199ZM9.20833 9.70866C9.20833 9.5208 9.13371 9.34063 9.00087 9.20779C8.86803 9.07495 8.68786 9.00033 8.5 9.00033C8.31214 9.00033 8.13197 9.07495 7.99913 9.20779C7.86629 9.34063 7.79167 9.5208 7.79167 9.70866V12.542C7.79167 12.7299 7.86629 12.91 7.99913 13.0429C8.13197 13.1757 8.31214 13.2503 8.5 13.2503C8.68786 13.2503 8.86803 13.1757 9.00087 13.0429C9.13371 12.91 9.20833 12.7299 9.20833 12.542V9.70866ZM6.375 11.1218C6.37406 10.9339 6.29853 10.7541 6.16503 10.622C6.03153 10.4898 5.85099 10.4161 5.66312 10.417C5.47526 10.4179 5.29547 10.4935 5.1633 10.627C5.03112 10.7605 4.95739 10.941 4.95833 11.1289L4.96542 12.5455C4.96636 12.7334 5.04188 12.9132 5.17539 13.0454C5.30889 13.1775 5.48943 13.2513 5.67729 13.2503C5.86515 13.2494 6.04495 13.1739 6.17712 13.0404C6.3093 12.9069 6.38302 12.7263 6.38208 12.5385L6.375 11.1218Z"
        fill="black"
      />
    </svg>
  );
}

function City() {
  return (
    <svg
      width="27"
      height="33"
      viewBox="0 0 27 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.75749 19.1016H2.49023V20.2352H4.75749V19.1016Z"
        fill="white"
      />
      <path
        d="M13.2594 19.1016H10.9922V20.2352H13.2594V19.1016Z"
        fill="white"
      />
      <path d="M13.2594 16.835H10.9922V17.9686H13.2594V16.835Z" fill="white" />
      <path d="M13.2594 14.5664H10.9922V15.7H13.2594V14.5664Z" fill="white" />
      <path
        d="M13.2594 12.2998H10.9922V13.4334H13.2594V12.2998Z"
        fill="white"
      />
      <path
        d="M16.0935 10.0322H10.9922V11.1659H16.0935V10.0322Z"
        fill="white"
      />
      <path
        d="M16.0935 7.76465H10.9922V8.89828H16.0935V7.76465Z"
        fill="white"
      />
      <path d="M16.0935 5.49707H10.9922V6.6307H16.0935V5.49707Z" fill="white" />
      <path
        d="M16.0935 3.23145H10.9922V4.36507H16.0935V3.23145Z"
        fill="white"
      />
      <path
        d="M4.75749 21.3682H2.49023V22.5018H4.75749V21.3682Z"
        fill="white"
      />
      <path
        d="M13.2594 21.3682H10.9922V22.5018H13.2594V21.3682Z"
        fill="white"
      />
      <path
        d="M4.75749 23.6357H2.49023V24.7694H4.75749V23.6357Z"
        fill="white"
      />
      <path
        d="M13.2594 23.6357H10.9922V24.7694H13.2594V23.6357Z"
        fill="white"
      />
      <path
        d="M4.75749 25.9033H2.49023V27.0369H4.75749V25.9033Z"
        fill="white"
      />
      <path
        d="M13.2594 25.9033H10.9922V27.0369H13.2594V25.9033Z"
        fill="white"
      />
      <path
        d="M7.59538 19.1016H5.32812V20.2352H7.59538V19.1016Z"
        fill="white"
      />
      <path
        d="M16.0973 19.1016H13.8301V20.2352H16.0973V19.1016Z"
        fill="white"
      />
      <path d="M16.0973 16.835H13.8301V17.9686H16.0973V16.835Z" fill="white" />
      <path d="M16.0973 14.5664H13.8301V15.7H16.0973V14.5664Z" fill="white" />
      <path
        d="M16.0973 12.2998H13.8301V13.4334H16.0973V12.2998Z"
        fill="white"
      />
      <path
        d="M7.59538 21.3682H5.32812V22.5018H7.59538V21.3682Z"
        fill="white"
      />
      <path
        d="M16.0973 21.3682H13.8301V22.5018H16.0973V21.3682Z"
        fill="white"
      />
      <path
        d="M7.59538 23.6357H5.32812V24.7694H7.59538V23.6357Z"
        fill="white"
      />
      <path
        d="M16.0973 23.6357H13.8301V24.7694H16.0973V23.6357Z"
        fill="white"
      />
      <path
        d="M7.59538 25.9033H5.32812V27.0369H7.59538V25.9033Z"
        fill="white"
      />
      <path
        d="M16.0973 25.9033H13.8301V27.0369H16.0973V25.9033Z"
        fill="white"
      />
      <path
        d="M25.7313 12.8664H18.3627V0.963299C18.3627 0.650417 18.1093 0.396484 17.7959 0.396484H9.29364C8.98019 0.396484 8.72683 0.650417 8.72683 0.963299V16.2673H0.791424C0.477975 16.2673 0.224609 16.5212 0.224609 16.8341V31.5713C0.224609 31.8842 0.477975 32.1381 0.791424 32.1381H3.05868H7.02638H9.29364H11.5609H15.5286H17.7959H20.0631H23.464H25.7313C26.0447 32.1381 26.2981 31.8842 26.2981 31.5713V13.4332C26.2981 13.1203 26.0447 12.8664 25.7313 12.8664ZM1.35824 17.4009H8.72683V31.0045H7.5932V28.7372C7.5932 28.4243 7.33983 28.1704 7.02638 28.1704H3.05868C2.74523 28.1704 2.49187 28.4243 2.49187 28.7372V31.0045H1.35824V17.4009ZM3.6255 31.0045V29.304H6.45957V31.0045H3.6255ZM9.86046 16.8341V1.53011H17.229V13.4332V31.0045H16.0954V28.7372C16.0954 28.4243 15.842 28.1704 15.5286 28.1704H11.5609C11.2475 28.1704 10.9941 28.4243 10.9941 28.7372V31.0045H9.86046V16.8341ZM12.1277 31.0045V29.304H14.9618V31.0045H12.1277ZM20.6299 31.0045V29.8708H22.8972V31.0045H20.6299ZM25.1644 31.0045H24.0308V29.304C24.0308 28.9911 23.7775 28.7372 23.464 28.7372H20.0631C19.7497 28.7372 19.4963 28.9911 19.4963 29.304V31.0045H18.3627V14H25.1644V31.0045Z"
        fill="white"
      />
      <path
        d="M20.6297 15.1338H19.4961V18.5347H20.6297V15.1338Z"
        fill="white"
      />
      <path d="M20.6297 19.668H19.4961V23.0689H20.6297V19.668Z" fill="white" />
      <path d="M20.6297 24.2031H19.4961V27.604H20.6297V24.2031Z" fill="white" />
      <path
        d="M24.0301 15.1338H22.8965V18.5347H24.0301V15.1338Z"
        fill="white"
      />
      <path d="M24.0301 19.668H22.8965V23.0689H24.0301V19.668Z" fill="white" />
      <path d="M24.0301 24.2031H22.8965V27.604H24.0301V24.2031Z" fill="white" />
      <path
        d="M22.3309 15.1338H21.1973V18.5347H22.3309V15.1338Z"
        fill="white"
      />
      <path d="M22.3309 19.668H21.1973V23.0689H22.3309V19.668Z" fill="white" />
      <path d="M22.3309 24.2031H21.1973V27.604H22.3309V24.2031Z" fill="white" />
    </svg>
  );
}

function Arrow() {
  return (
    <svg
      width="43"
      height="20"
      viewBox="0 0 43 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.37305 8.59052C0.642613 8.59052 0.0504798 9.18265 0.0504798 9.91309C0.0504797 10.6435 0.642613 11.2357 1.37305 11.2357L1.37305 8.59052ZM41.9853 10.8483C42.5018 10.3318 42.5018 9.49439 41.9853 8.97789L33.5685 0.561127C33.052 0.0446328 32.2146 0.0446327 31.6981 0.561126C31.1816 1.07762 31.1816 1.91502 31.6981 2.43152L39.1797 9.91309L31.6981 17.3947C31.1816 17.9112 31.1816 18.7486 31.6981 19.2651C32.2146 19.7815 33.052 19.7815 33.5685 19.2651L41.9853 10.8483ZM1.37305 11.2357L41.0501 11.2357L41.0501 8.59052L1.37305 8.59052L1.37305 11.2357Z"
        fill="white"
      />
    </svg>
  );
}

function Group() {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.7192 22.8469L28.2177 18.5879H19.8491L17.3476 22.8469V30.0357H15.1674V22.8469L12.666 18.5879H4.29729L1.79585 22.8469V30.0357H0.386719V31.9594H32.1283V30.0357H30.7192V22.8469ZM27.1166 20.5116L28.0769 22.1466H19.99L20.9502 20.5116H27.1166ZM19.2714 24.0703H28.7955V30.0357H24.9953V26.3147H23.0715V30.0357H19.2714V24.0703ZM11.5648 20.5116L12.5251 22.1466H4.43817L5.39843 20.5116H11.5648ZM3.71959 24.0703H13.2437V30.0357H9.44347V26.3147H7.51973V30.0357H3.71959V24.0703Z"
        fill="white"
      />
      <path
        d="M30.7192 12.3873V5.19847L28.2177 0.939453H19.8491L17.3476 5.19847V12.3873H15.1674V5.19847L12.666 0.939453H4.29729L1.79585 5.19847V12.3873H0.386719V14.311H32.1283V12.3873H30.7192ZM27.1166 2.86319L28.0769 4.49823H19.99L20.9502 2.86319H27.1166ZM19.2714 6.42197H28.7955V12.3873H24.9953V8.66632H23.0715V12.3873H19.2714V6.42197ZM11.5648 2.86319L12.5251 4.49823H4.43817L5.39843 2.86319H11.5648ZM3.71959 6.42197H13.2437V12.3873H9.44347V8.66632H7.51973V12.3873H3.71959V6.42197Z"
        fill="white"
      />
    </svg>
  );
}

function Faoliyat() {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5955 7.51758C14.5133 7.51758 14.4368 7.55946 14.3923 7.62861L11.4191 12.2623C11.3677 12.3423 11.3682 12.445 11.4201 12.5246C11.4721 12.6043 11.5664 12.6458 11.6599 12.6312L13.6026 12.3244V17.8912V20.4008V23.7871H15.5884V20.4008V18.8841H19.4209L19.1142 20.8267C19.0993 20.9206 19.141 21.0145 19.2206 21.0665C19.2607 21.0926 19.3067 21.1057 19.3527 21.1057C19.3979 21.1057 19.4433 21.093 19.483 21.0675L24.1167 18.0943C24.1859 18.0499 24.2278 17.9733 24.2278 17.8911C24.2278 17.8089 24.186 17.7323 24.1167 17.6879L19.483 14.7147C19.403 14.6633 19.3002 14.6637 19.2206 14.7157C19.141 14.7677 19.0993 14.8616 19.1142 14.9555L19.421 16.8981H15.5884V12.3243L17.531 12.6311C17.5436 12.633 17.5562 12.634 17.5687 12.634C17.6493 12.634 17.7258 12.5935 17.7708 12.5246C17.8227 12.445 17.8232 12.3423 17.7718 12.2623L14.7986 7.62861C14.7543 7.55946 14.6777 7.51758 14.5955 7.51758Z"
        fill="white"
      />
      <path
        d="M31.753 15.7217L17.1565 1.12518C16.6589 0.627546 15.8522 0.627546 15.3545 1.12518L0.757988 15.7217C0.260358 16.2194 0.260358 17.0261 0.757988 17.5238L15.3545 32.1203C15.6033 32.3691 15.9294 32.4934 16.2554 32.4934C16.5816 32.4934 16.9077 32.3691 17.1564 32.1203L31.7529 17.5238C32.2507 17.0261 32.2507 16.2193 31.753 15.7217ZM16.2554 29.4172L3.46089 16.6227L16.2554 3.82824L29.0499 16.6227L16.2554 29.4172Z"
        fill="white"
      />
    </svg>
  );
}

function Yunalishlar() {
  return (
    <svg
      width="33"
      height="12"
      viewBox="0 0 33 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.1283 7.36072L27.1856 4.14329C26.8923 3.95239 26.5042 4.16284 26.5042 4.51276V5.79782H24.3565C23.2035 2.43266 20.0086 0.00683594 16.2576 0.00683594C12.5065 0.00683594 9.31161 2.43266 8.15866 5.79782H6.0108V4.52193C6.0108 4.17227 5.62322 3.96177 5.32992 4.15215L0.386719 7.36072L5.32944 10.5781C5.6227 10.769 6.0108 10.5586 6.0108 10.2087V8.92362H11.179L11.1746 8.90016H11.181V8.56502C11.181 5.76585 13.4583 3.48856 16.2574 3.48856C19.0565 3.48856 21.3339 5.76591 21.3339 8.56502V8.7352L21.2961 8.92362H26.504V10.2087C26.504 10.5586 26.8921 10.7691 27.1854 10.5782L32.1283 7.36072Z"
        fill="white"
      />
      <path
        d="M16.2572 5.47852C14.5085 5.47852 13.0859 6.90119 13.0859 8.64983C13.0859 10.3985 14.5086 11.8212 16.2572 11.8212C18.0059 11.8212 19.4286 10.3985 19.4286 8.64983C19.4286 6.90119 18.006 5.47852 16.2572 5.47852Z"
        fill="white"
      />
    </svg>
  );
}

function Xodimlar() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8692 16.5314C19.1573 16.5314 21.8205 13.8682 21.8205 10.5802C21.8205 7.29209 19.1573 4.62891 15.8692 4.62891C12.5812 4.62891 9.91797 7.29209 9.91797 10.5802C9.91797 13.8682 12.5812 16.5314 15.8692 16.5314Z"
        fill="white"
      />
      <path
        d="M11.1603 18.6475C11.4927 18.5664 11.8338 18.7323 11.9847 19.0394L14.672 25.8317L15.0665 21.1992C15.094 20.9683 14.9179 20.7874 14.7534 20.623C14.3815 20.2511 14.3815 18.7633 14.7534 18.3913C14.8726 18.2721 15.1063 18.3057 15.3813 18.3452C15.5354 18.3673 15.7023 18.3912 15.8693 18.3912C16.0362 18.3912 16.2032 18.3673 16.3572 18.3451C16.6322 18.3056 16.866 18.2721 16.9852 18.3913C17.3571 18.7633 17.3571 20.2511 16.9852 20.623C16.8196 20.7885 16.6449 20.9747 16.6726 21.2072L17.0665 25.8319L19.7539 19.0394C19.9048 18.7323 20.2458 18.5664 20.5783 18.6475C24.1518 19.5192 27.7718 21.2966 27.7718 23.9705V28.434H3.9668V23.9705C3.9668 21.2966 7.58681 19.5192 11.1603 18.6475Z"
        fill="white"
      />
    </svg>
  );
}

function Hudud() {
  return (
    <svg
      width="33"
      height="27"
      viewBox="0 0 33 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.82952 11.8344H4.71512H12.4101H20.105H27.7999H30.6855C31.4823 11.8344 32.1283 11.1884 32.1283 10.3916C32.1283 9.59478 31.4823 8.94879 30.6855 8.94879H29.2427V4.62039C29.2427 4.1663 29.0289 3.73865 28.6656 3.46615L24.8181 0.580552C24.3051 0.195805 23.5998 0.195805 23.0868 0.580552L20.105 2.81689L17.1232 0.580648C16.6101 0.195902 15.9049 0.195902 15.3918 0.580648L12.4101 2.81699L9.42827 0.580648C8.91521 0.195902 8.20997 0.195902 7.69691 0.580648L3.84944 3.46625C3.48614 3.73875 3.27232 4.16639 3.27232 4.62049V8.94889H1.82952C1.03271 8.94889 0.386719 9.59488 0.386719 10.3917C0.386719 11.1885 1.03271 11.8344 1.82952 11.8344ZM23.9525 3.53839L26.3571 5.34179V8.94879H21.5478V5.34179L23.9525 3.53839ZM16.2575 3.53839L18.6622 5.34179V8.94879H13.8529V5.34179L16.2575 3.53839ZM6.15792 5.34179L8.56259 3.53839L10.9673 5.34179V8.94879H6.15792V5.34179Z"
        fill="white"
      />
      <path
        d="M30.6855 23.3765H29.2427V19.0481C29.2427 18.594 29.0289 18.1664 28.6656 17.8939L24.8181 15.0083C24.3051 14.6235 23.5998 14.6235 23.0868 15.0083L20.105 17.2446L17.1232 15.0083C16.6101 14.6235 15.9049 14.6235 15.3918 15.0083L12.4101 17.2446L9.42827 15.0083C8.91521 14.6235 8.20997 14.6235 7.69691 15.0083L3.84944 17.8939C3.48614 18.1664 3.27232 18.594 3.27232 19.0481V23.3765H1.82952C1.03271 23.3765 0.386719 24.0225 0.386719 24.8193C0.386719 25.6161 1.03271 26.2621 1.82952 26.2621H4.71512H12.4101H20.105H27.7999H30.6855C31.4823 26.2621 32.1283 25.6161 32.1283 24.8193C32.1283 24.0225 31.4823 23.3765 30.6855 23.3765ZM6.15792 19.7695L8.56259 17.966L10.9673 19.7695V23.3765H6.15792V19.7695ZM13.8529 19.7695L16.2575 17.966L18.6622 19.7695V23.3765H13.8529V19.7695ZM21.5478 23.3765V19.7695L23.9525 17.966L26.3571 19.7695V23.3765H21.5478Z"
        fill="white"
      />
    </svg>
  );
}

function Reklamalar() {
  return (
    <svg
      width="32"
      height="29"
      viewBox="0 0 32 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.2608 1.00997L12.9781 7.08844L5.70881 6.90817C4.26352 6.87259 3.08412 8.03538 3.08412 9.46864V10.0253H3.06552C1.37524 10.0252 0 11.4005 0 13.0908C0 14.7812 1.37524 16.1564 3.06558 16.1564H3.08412V16.7733C3.08412 18.1624 4.21405 19.3112 5.60299 19.3342L6.47485 19.3487L5.87253 25.3405C5.68724 27.1836 7.13612 28.793 8.99539 28.793H9.00209C10.6206 28.793 11.963 27.5786 12.125 25.9683L12.2392 24.8318C12.5357 24.8892 12.8413 24.9203 13.1542 24.9203C15.4753 24.9203 17.417 23.2657 17.8624 21.074L30.2806 25.1785C30.9955 25.4148 31.7399 24.8838 31.7399 24.1239V2.05783C31.7401 1.29229 30.9822 0.75624 30.2608 1.00997ZM13.1543 22.6987C12.9149 22.6987 12.6833 22.6653 12.4632 22.6041L12.7823 19.4028L15.7248 20.3674C15.5978 21.6741 14.4936 22.6987 13.1543 22.6987ZM21.6326 15.6827H17.3751C16.7617 15.6827 16.2644 15.1854 16.2644 14.572C16.2644 13.9586 16.7617 13.4613 17.3751 13.4613H21.6326C22.246 13.4613 22.7433 13.9586 22.7433 14.572C22.7433 15.1854 22.246 15.6827 21.6326 15.6827ZM21.6326 11.9802H17.3751C16.7617 11.9802 16.2644 11.4829 16.2644 10.8695C16.2644 10.2561 16.7617 9.75876 17.3751 9.75876H21.6326C22.246 9.75876 22.7433 10.2561 22.7433 10.8695C22.7433 11.4829 22.246 11.9802 21.6326 11.9802Z"
        fill="white"
      />
    </svg>
  );
}

function AddItem() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99998 14.6667C4.31798 14.6667 1.33331 11.682 1.33331 8.00001C1.33331 4.31801 4.31798 1.33334 7.99998 1.33334C11.682 1.33334 14.6666 4.31801 14.6666 8.00001C14.6666 11.682 11.682 14.6667 7.99998 14.6667ZM7.33331 7.33334H4.66665V8.66668H7.33331V11.3333H8.66665V8.66668H11.3333V7.33334H8.66665V4.66668H7.33331V7.33334Z"
        fill="#4447E2"
      />
    </svg>
  );
}

function AddFile() {
  return (
    <svgAddFolder
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6667 1.33334L14 4.66668V14.0053C13.9998 14.1808 13.93 14.349 13.8059 14.473C13.6817 14.597 13.5135 14.6667 13.338 14.6667H2.662C2.48692 14.6655 2.31934 14.5954 2.19548 14.4717C2.07161 14.3479 2.0014 14.1804 2 14.0053V1.99468C2 1.62934 2.29667 1.33334 2.662 1.33334H10.6667ZM7.33333 7.33334H5.33333V8.66668H7.33333V10.6667H8.66667V8.66668H10.6667V7.33334H8.66667V5.33334H7.33333V7.33334Z"
        fill="#4447E2"
      />
    </svgAddFolder>
  );
}

function AddFolder() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.27604 3.33333H14C14.1769 3.33333 14.3464 3.40357 14.4714 3.5286C14.5965 3.65362 14.6667 3.82319 14.6667 4V13.3333C14.6667 13.5101 14.5965 13.6797 14.4714 13.8047C14.3464 13.9298 14.1769 14 14 14H2.00004C1.82323 14 1.65366 13.9298 1.52864 13.8047C1.40361 13.6797 1.33337 13.5101 1.33337 13.3333V2.66667C1.33337 2.48986 1.40361 2.32029 1.52864 2.19526C1.65366 2.07024 1.82323 2 2.00004 2H6.94271L8.27604 3.33333ZM7.33337 8H5.33337V9.33333H7.33337V11.3333H8.66671V9.33333H10.6667V8H8.66671V6H7.33337V8Z"
        fill="#4447E2"
      />
    </svg>
  );
}

function CopyFolder() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.00004 4.66667V2.66667C4.00004 2.48986 4.07028 2.32029 4.1953 2.19526C4.32033 2.07024 4.4899 2 4.66671 2H8.94271L10.276 3.33333H14C14.1769 3.33333 14.3464 3.40357 14.4714 3.5286C14.5965 3.65362 14.6667 3.82319 14.6667 4V10.6667C14.6667 10.8435 14.5965 11.013 14.4714 11.1381C14.3464 11.2631 14.1769 11.3333 14 11.3333H12V13.3333C12 13.5101 11.9298 13.6797 11.8048 13.8047C11.6798 13.9298 11.5102 14 11.3334 14H2.00004C1.82323 14 1.65366 13.9298 1.52864 13.8047C1.40361 13.6797 1.33337 13.5101 1.33337 13.3333V5.33333C1.33337 5.15652 1.40361 4.98695 1.52864 4.86193C1.65366 4.7369 1.82323 4.66667 2.00004 4.66667H4.00004ZM4.00004 6H2.66671V12.6667H10.6667V11.3333H4.00004V6Z"
        fill="#4447E2"
      />
    </svg>
  );
}

function TransferFolder() {
  return (
    <svg
      width="15"
      height="13"
      viewBox="0 0 15 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6667 6.75067C12.9239 6.2167 12.0205 5.9535 11.1071 6.00495C10.1937 6.05639 9.32554 6.41937 8.64737 7.03337C7.96919 7.64737 7.52198 8.47528 7.38028 9.37907C7.23859 10.2829 7.41098 11.2079 7.86871 12H1.00004C0.82323 12 0.65366 11.9298 0.528636 11.8047C0.403612 11.6797 0.333374 11.5101 0.333374 11.3333V0.666667C0.333374 0.489856 0.403612 0.320286 0.528636 0.195262C0.65366 0.0702379 0.82323 0 1.00004 0H5.94271L7.27604 1.33333H13C13.1769 1.33333 13.3464 1.40357 13.4714 1.5286C13.5965 1.65362 13.6667 1.82319 13.6667 2V6.75067ZM12.3334 9.33333H14.3334V10.6667H12.3334V13L9.00004 10L12.3334 7V9.33333Z"
        fill="#4447E2"
      />
    </svg>
  );
}

function EditFile() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 9.16201V13.0053C11.9998 13.1808 11.93 13.349 11.8059 13.473C11.6818 13.597 11.5135 13.6667 11.338 13.6667H0.662017C0.574468 13.6661 0.487897 13.6482 0.407247 13.6141C0.326597 13.5801 0.253447 13.5305 0.191974 13.4681C0.130501 13.4058 0.0819094 13.3319 0.0489732 13.2508C0.016037 13.1697 -0.000598536 13.0829 1.64487e-05 12.9953V5.00001H4.00002C4.17683 5.00001 4.3464 4.92977 4.47142 4.80475C4.59645 4.67972 4.66668 4.51015 4.66668 4.33334V0.333344H11.3347C11.702 0.333344 12 0.636677 12 0.994677V3.50468L6.00068 9.50468L5.99668 12.33L8.82735 12.334L12 9.16201ZM12.5187 4.87201L13.4613 5.81468L8.27602 11L7.33202 10.9987L7.33335 10.0573L12.5187 4.87201ZM1.64487e-05 3.66668L3.33335 0.335344V3.66668H1.64487e-05Z"
        fill="#4447E2"
      />
    </svg>
  );
}

function Antenna() {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 9.33333L3 3.33333V2H15V3.33333L10.5 9.33333V13.3333L7.5 14.6667V9.33333Z"
        fill="#4447E2"
      />
    </svg>
  );
}

function AntennaReceive() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 3.99999V2.66666H2V3.99999H2.66667L6.66667 9.99999V14.6667H9.33333V9.99999L13.3333 3.99999H14ZM8.5 3.99983H7.5V5.99991H6.66667L8 7.66657L9.33333 5.99991H8.5V3.99983Z"
        fill="#4447E2"
      />
    </svg>
  );
}

function DeleteItem() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.61933 0.343353L14.0467 9.77135L13.104 10.714L10.5553 8.16602L9.33333 10V14.6667H6.66667V10L2.66667 4.00002H2V2.66669H5.05667L3.67667 1.28602L4.61933 0.343353ZM14 2.66669V4.00002H13.3333L12.0567 5.91469L8.80867 2.66669H14Z"
        fill="#BAC8DC"
      />
    </svg>
  );
}

function EditIcon() {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 217.855 217.855"
    >
      <path
        d="M215.658,53.55L164.305,2.196C162.899,0.79,160.991,0,159.002,0c-1.989,0-3.897,0.79-5.303,2.196L3.809,152.086
	c-1.35,1.352-2.135,3.166-2.193,5.075l-1.611,52.966c-0.063,2.067,0.731,4.069,2.193,5.532c1.409,1.408,3.317,2.196,5.303,2.196
	c0.076,0,0.152-0.001,0.229-0.004l52.964-1.613c1.909-0.058,3.724-0.842,5.075-2.192l149.89-149.889
	C218.587,61.228,218.587,56.479,215.658,53.55z M57.264,201.336l-42.024,1.28l1.279-42.026l91.124-91.125l40.75,40.743
	L57.264,201.336z M159,99.602l-40.751-40.742l40.752-40.753l40.746,40.747L159,99.602z"
      />
    </svg>
  );
}

function DeleteIcon(width, height) {
  return (
    <svg
      width={width || "1044px"}
      height={height || "1044px"}
      viewBox="0 0 884 1004"
      xmlns="http://www.w3.org/2000/svg"
      className="icon"
    >
      <path d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" />
    </svg>
  );
}

function Circle() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00004 14.6667C4.31804 14.6667 1.33337 11.682 1.33337 8.00001C1.33337 4.31801 4.31804 1.33334 8.00004 1.33334C11.682 1.33334 14.6667 4.31801 14.6667 8.00001C14.6667 11.682 11.682 14.6667 8.00004 14.6667ZM11.2134 11.384C12.0181 10.6213 12.525 9.59688 12.6432 8.49441C12.7613 7.39194 12.4831 6.28341 11.8583 5.36742C11.2335 4.45142 10.303 3.78781 9.23347 3.49547C8.16392 3.20313 7.02522 3.30116 6.02137 3.77201L6.67137 4.94201C7.17866 4.72153 7.73283 4.63076 8.28395 4.67787C8.83506 4.72498 9.36579 4.9085 9.82829 5.21187C10.2908 5.51525 10.6705 5.92895 10.9333 6.41568C11.196 6.90242 11.3335 7.44689 11.3334 8.00001H9.33337L11.2134 11.384ZM9.97871 12.228L9.32871 11.058C8.82142 11.2785 8.26725 11.3693 7.71613 11.3221C7.16502 11.275 6.63429 11.0915 6.17179 10.7881C5.70928 10.4848 5.32954 10.0711 5.0668 9.58434C4.80405 9.0976 4.66656 8.55313 4.66671 8.00001H6.66671L4.78671 4.61601C3.98197 5.37877 3.4751 6.40314 3.35692 7.50561C3.23874 8.60808 3.51697 9.71661 4.14175 10.6326C4.76653 11.5486 5.69705 12.2122 6.76661 12.5046C7.83616 12.7969 8.97486 12.6989 9.97871 12.228Z"
        fill="#4447E2"
      />
    </svg>
  );
}

function MacRed() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6" cy="6" r="6" fill="#F65951" />
    </svg>
  );
}

function MacGreen() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6" cy="6" r="6" fill="#24C33D" />
    </svg>
  );
}

function MacYellow() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6" cy="6" r="6" fill="#F7B629" />
    </svg>
  );
}

function UploadFilePasport() {
  return (
    <svg
      width="25"
      height="29"
      viewBox="0 0 25 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 24.125C0 25.219 0.434597 26.2682 1.20818 27.0418C1.98177 27.8154 3.03098 28.25 4.125 28.25H20.625C21.719 28.25 22.7682 27.8154 23.5418 27.0418C24.3154 26.2682 24.75 25.219 24.75 24.125V10.1385C24.7494 9.04505 24.3147 7.99657 23.5414 7.2235L18.2779 1.95725C17.5042 1.18411 16.4552 0.749869 15.3615 0.75H4.125C3.03098 0.75 1.98177 1.1846 1.20818 1.95818C0.434597 2.73177 0 3.78098 0 4.875V24.125ZM4.125 25.5C3.76033 25.5 3.41059 25.3551 3.15273 25.0973C2.89487 24.8394 2.75 24.4897 2.75 24.125V4.875C2.75 4.51033 2.89487 4.16059 3.15273 3.90273C3.41059 3.64487 3.76033 3.5 4.125 3.5H13.75V7.625C13.75 8.71902 14.1846 9.76823 14.9582 10.5418C15.7318 11.3154 16.781 11.75 17.875 11.75H22V24.125C22 24.4897 21.8551 24.8394 21.5973 25.0973C21.3394 25.3551 20.9897 25.5 20.625 25.5H4.125ZM21.4307 9H17.875C17.5103 9 17.1606 8.85513 16.9027 8.59727C16.6449 8.33941 16.5 7.98967 16.5 7.625V4.06925L21.4307 9Z"
        fill="#888"
      />
    </svg>
  );
}

function UploadFileOilasi() {
  return (
    <svg
      width="25"
      height="29"
      viewBox="0 0 25 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.125 24.125C0.125 25.219 0.559597 26.2682 1.33318 27.0418C2.10677 27.8154 3.15598 28.25 4.25 28.25H20.75C21.844 28.25 22.8932 27.8154 23.6668 27.0418C24.4404 26.2682 24.875 25.219 24.875 24.125V10.1385C24.8744 9.04505 24.4397 7.99657 23.6664 7.2235L18.4029 1.95725C17.6292 1.18411 16.5802 0.749869 15.4865 0.75H4.25C3.15598 0.75 2.10677 1.1846 1.33318 1.95818C0.559597 2.73177 0.125 3.78098 0.125 4.875V24.125ZM4.25 25.5C3.88533 25.5 3.53559 25.3551 3.27773 25.0973C3.01987 24.8394 2.875 24.4897 2.875 24.125V4.875C2.875 4.51033 3.01987 4.16059 3.27773 3.90273C3.53559 3.64487 3.88533 3.5 4.25 3.5H13.875V7.625C13.875 8.71902 14.3096 9.76823 15.0832 10.5418C15.8568 11.3154 16.906 11.75 18 11.75H22.125V24.125C22.125 24.4897 21.9801 24.8394 21.7223 25.0973C21.4644 25.3551 21.1147 25.5 20.75 25.5H4.25ZM21.5557 9H18C17.6353 9 17.2856 8.85513 17.0277 8.59727C16.7699 8.33941 16.625 7.98967 16.625 7.625V4.06925L21.5557 9Z"
        fill="#888"
      />
      <path
        d="M12.5 12.125C12.8647 12.125 13.2144 12.2699 13.4723 12.5277C13.7301 12.7856 13.875 13.1353 13.875 13.5V16.25H16.625C16.9897 16.25 17.3394 16.3949 17.5973 16.6527C17.8551 16.9106 18 17.2603 18 17.625C18 17.9897 17.8551 18.3394 17.5973 18.5973C17.3394 18.8551 16.9897 19 16.625 19H13.875V21.75C13.875 22.1147 13.7301 22.4644 13.4723 22.7223C13.2144 22.9801 12.8647 23.125 12.5 23.125C12.1353 23.125 11.7856 22.9801 11.5277 22.7223C11.2699 22.4644 11.125 22.1147 11.125 21.75V19H8.375C8.01033 19 7.66059 18.8551 7.40273 18.5973C7.14487 18.3394 7 17.9897 7 17.625C7 17.2603 7.14487 16.9106 7.40273 16.6527C7.66059 16.3949 8.01033 16.25 8.375 16.25H11.125V13.5C11.125 13.1353 11.2699 12.7856 11.5277 12.5277C11.7856 12.2699 12.1353 12.125 12.5 12.125Z"
        fill="#888"
      />
    </svg>
  );
}

function Plus() {
  return (
    <svg
      width="20px"
      height="12px"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99967 14.6668V8.00016M7.99967 8.00016V1.3335M7.99967 8.00016H14.6663M7.99967 8.00016H1.33301"
        stroke="#d9d9d9"
        strokeWidth="1.66667"
        strokeLinecap="round"
      />
    </svg>
  );
}

function FileBlueIcon() {
  return (
    <svg
      width={"33px"}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 496 496"
    >
      <path
        style={{ fill: "#0EE0B8" }}
        d="M404,0H92C78.4,0,64,12.8,64,26.4v320L222.4,496H404c13.6,0,28-12.8,28-26.4V26.4
	C432,12.8,417.6,0,404,0z"
      />
      <path
        style={{ fill: "#1080DD" }}
        d="M404,0H92C78.4,0,64,12.8,64,26.4v320L222.4,496H404c13.6,0,28-12.8,28-26.4V26.4
	C432,12.8,417.6,0,404,0z"
      />
      <path
        style={{ fill: "#0070CC" }}
        d="M432,384V26.4C432,12.8,417.6,0,404,0H92C78.4,0,66.4,11.2,66.4,24"
      />
      <path
        style={{ fill: "#0667B7" }}
        d="M432,384V26.4C432,12.8,417.6,0,404,0H208"
      />
      <path
        style={{ fill: "#0070CC" }}
        d="M200,352v119.2c0,1.6,1.6,3.2,1.6,4.8l19.2,18.4c1.6,0,3.2,1.6,4.8,1.6h125.6l-148-144H200z"
      />
      <path
        style={{ fill: "#0667B7" }}
        d="M200,351.2v120c0,1.6,1.6,3.2,1.6,4.8l19.2,18.4c1.6,0,3.2,1.6,4.8,1.6h64l-72.8-120.8L200,351.2z"
      />
      <path
        style={{ fill: "#FFFFFF;" }}
        d="M222.4,496h1.6V370.4c0-13.6-12-26.4-25.6-26.4L64,345.6L222.4,496z"
      />
      <polyline
        style={{ fill: "#D2F3FF;" }}
        points="64,345.6 222.4,496 224,496 224,368 "
      />
      <path
        style={{ fill: "#3DB8FC" }}
        d="M80,345.6L80,345.6V26.4C80,12.8,89.6,0,102.4,0H92C78.4,0,64,12.8,64,26.4v320L80,345.6L80,345.6z"
      />
      <path
        style={{ fill: "#0667B7" }}
        d="M349.6,161.6L320,132c-6.4-6.4-15.2-10.4-24.8-10.4c-9.6,0-17.6,4-24.8,10.4L140,261.6
	c-4.8,4.8-4.8,12,0,16c4.8,4.8,12,4.8,16,0l130.4-130.4c4-4,12-4,16,0l29.6,29.6c2.4,2.4,3.2,4.8,3.2,8s-1.6,5.6-3.2,8l-44,45.6
	c0,0-0.8,0-0.8,0.8l-74.4,74.4c-0.8,0.8-1.6,0.8-2.4,0l-16.8-16.8c-0.8-0.8-0.8-1.6,0-2.4l49.6-49.6c4.8-4.8,4.8-12,0-16
	c-4.8-4.8-12-4.8-16,0l-49.6,49.6c-9.6,9.6-9.6,25.6,0,35.2l16.8,16.8c4.8,4.8,11.2,7.2,17.6,7.2s12.8-2.4,17.6-7.2l32.8-32.8
	c0,0,0.8,0,0.8-0.8l86.4-86.4c6.4-6.4,10.4-15.2,10.4-24.8C359.2,176.8,356,168,349.6,161.6z"
      />
      <path
        style={{ fill: "#FFFFFF;" }}
        d="M349.6,139.2L320,109.6c-6.4-6.4-15.2-10.4-24.8-10.4c-9.6,0-17.6,4-24.8,10.4L140,240
                c-4.8,4.8-4.8,12,0,16s12,4.8,16,0l130.4-130.4c4-4,12-4,16,0l29.6,29.6c2.4,2.4,3.2,4.8,3.2,8s-1.6,5.6-3.2,8l-44,45.6
                c0,0-0.8,0-0.8,0.8L212.8,292c-0.8,0.8-1.6,0.8-2.4,0l-16.8-16.8c-0.8-0.8-0.8-1.6,0-2.4l49.6-49.6c4.8-4.8,4.8-12,0-16
                c-4.8-4.8-12-4.8-16,0L177.6,256c-9.6,9.6-9.6,25.6,0,35.2l16.8,16.8c4.8,4.8,11.2,7.2,17.6,7.2s12.8-2.4,17.6-7.2l32.8-32.8
                c0,0,0.8,0,0.8-0.8l86.4-86.4c6.4-6.4,10.4-15.2,10.4-24.8C359.2,154.4,356,145.6,349.6,139.2z"
      />
    </svg>
  );
}

function Location() {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="20px"
      height="20px"
      viewBox="0 0 264.018 264.018"
    >
      <g>
        <path
          d="M132.009,0c-42.66,0-77.366,34.706-77.366,77.366c0,11.634,2.52,22.815,7.488,33.24c0.1,0.223,0.205,0.442,0.317,0.661
          l58.454,113.179c2.146,4.154,6.431,6.764,11.106,6.764c4.676,0,8.961-2.609,11.106-6.764l58.438-113.148
          c0.101-0.195,0.195-0.392,0.285-0.591c5.001-10.455,7.536-21.67,7.536-33.341C209.375,34.706,174.669,0,132.009,0z
           M132.009,117.861c-22.329,0-40.495-18.166-40.495-40.495c0-22.328,18.166-40.494,40.495-40.494s40.495,18.166,40.495,40.494
          C172.504,99.695,154.338,117.861,132.009,117.861z"
        />
        <path
          d="M161.81,249.018h-59.602c-4.143,0-7.5,3.357-7.5,7.5c0,4.143,3.357,7.5,7.5,7.5h59.602c4.143,0,7.5-3.357,7.5-7.5
          C169.31,252.375,165.952,249.018,161.81,249.018z"
        />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}

export {
  CompanyLogo,
  MainIcon,
  ProfileIconDiagrammIcon,
  GlobusIcon,
  GlobusIcon2,
  TelegramIcon,
  ServiceIcon,
  CloseIconSmall,
  CloseIcon,
  ProfileIcon,
  VectorIcon,
  City,
  Arrow,
  Group,
  Faoliyat,
  Yunalishlar,
  Xodimlar,
  Hudud,
  Reklamalar,
  AddItem,
  AddFile,
  AddFolder,
  CopyFolder,
  TransferFolder,
  EditFile,
  Antenna,
  AntennaReceive,
  DeleteItem,
  Circle,
  MacRed,
  MacGreen,
  MacYellow,
  DeleteIcon,
  DashIcon,
  UploadFilePasport,
  UploadFileOilasi,
  FileBlueIcon,
  Plus,
  Location,
  EditIcon,
  CloseIconForTab,
  UsersIcon,
};

